/**
 * Expert Application Routes
 *
 * Centralized route definitions for the expert application
 */
export const EXPERT_ROUTES = {
  // Auth routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  EXPERT_LOGIN: '/expertlogin',
  RESET_PASSWORD: '/reset-password',
  SET_PASSWORD: '/set-password',

  // App routes
  HOME: '/',

  // Workspace routes
  WORKSPACE: '/workspace',
  WORKSPACE_CREATE: '/workspace/create',
  ACCOUNT_SETTINGS: '/settings/account',
  CLIENT_INVITES_NOTIFICATION: '/client-invites-notification',

  // Expert settings routes
  SETTINGS: '/settings',
  SETTINGS_PERSONAL_INFO: '/settings/personal-info',
  SETTINGS_LOGIN_METHODS: '/settings/login-methods',
  SETTINGS_WORKSPACE_INFO: '/settings/workspace-info',
  SETTINGS_MEMBERS: '/settings/members',
  SETTINGS_INTEGRATIONS: '/settings/integrations',
  PEPPOL_SETTINGS: '/settings/peppol',
  SETTINGS_SEATS: '/settings/seats',

  // Purchase seats
  PURCHASE_SEATS: '/purchase-seats',

  // Customer routes
  CUSTOMERS_LIST: '/',
  CUSTOMER_BANKS: '/customer/:id/banks',
  CUSTOMER_EXPENSES: '/customer/:id/expenses',
  CUSTOMER_REVENUES: '/customer/:id/revenues',

  // Catch all
  NOT_FOUND: '*',
} as const;
